/** @jsx jsx */
import React, { useState } from 'react';
import ProgressiveImage from 'react-progressive-image';
import { jsx, Text, Heading, Grid, Button } from 'theme-ui';
import { Modal } from 'antd';
import { ethers } from 'ethers';
import confetti from 'canvas-confetti';
import { products } from './data/products-json';
import FsLightbox from 'fslightbox-react';
const axios = require('axios');

export default function SmartContractWallet(props) {
	const { product } = props;
	const [toggler, setToggler] = useState(false);

	const productDesc = async (product) => {
		/* console.log('VOTE RESPONSE:', response); */
		Modal.error({
			title: `Product Details`,
			centered: true,
			okText: 'Close',
			maskClosable: true,
			className: 'modal_c',
			content: (
				<div>
					<p>
						{product.desc}
					</p>
				</div>
			)

		});
	}

	const castVote = async (emoji, emojiName) => {
		if (props.SwaggBalance <= 0) {
			Modal.error({
				title: 'Hello There',
				centered: true,
				okText: 'Buy $SWAGG',
				maskClosable: true,
				className: 'modal_c',
				content: (
					<div>
						<p>You don't have enough $SWAGG in order to cast a vote. Get some on Uniswap Exchange.</p>
					</div>
				),
				onOk() {
					buylink();
				}
			});
			return;
		}
		let timestamp = Date.now();
		/* console.log('timestamp', timestamp);
		console.log('props.injectedProvider', props.injectedProvider); */
		let signer = props.injectedProvider.getSigner();
		/* console.log('props.address', props.address); */
		let message = 'kodevote' + emojiName + timestamp;
		/* console.log('message', message); */
		let result = await signer.signMessage(message);
		/* console.log('result', result); */
		let recovered = await ethers.utils.verifyMessage(message, result);
		/* console.log('recovered', recovered); */

		/// modal click functions
		function buylink() {
			window.open('https://uniswap.exchange/swap?outputCurrency=0xa19A40FbD7375431fAB013a4B08F00871B9a2791');
		}

		function sharetwitter() {
			window.open(
				`https://twitter.com/intent/tweet?text=Casting my $SWAGG vote for @kodehype "${emoji}" design → https://vote.kodehype.com`
			);
		}




		/// CHANGE THIS TO YOUR ZAP:
		axios
			.get(
				'https://hooks.zapier.com/hooks/catch/2348219/osn8snw/?address=' +
				props.address +
				'&vote=' +
				emoji +
				'&timestamp=' +
				timestamp +
				'&signature=' +
				result
			)
			.then(function (response) {
				/* console.log('VOTE RESPONSE:', response); */
				Modal.error({
					title: `You voted for #${emoji}!`,
					centered: true,
					okText: 'Share on twitter',
					maskClosable: true,
					className: 'modal_c',
					content: (
						<div>
							<p>
								Thanks for taking part on this exciting experiment. The winning design will be announced
								shortly. Meanwhile
								<a
									href="https://app.tryroll.com/claim/SWAGG-RAsCzwch2HWj"
									alt="SWAGG airdrop"
									target="_blank"
									className="swagglink"
								>
									&nbsp;here's some $SWAGG for being awesome.
								</a>
							</p>
						</div>
					),
					onOk() {
						sharetwitter();
					}
				});
				confetti({
					particleCount: 8000,
					startVelocity: 100,
					spread: 500,
					angle: 115,
					origin: {
						x: 0.4,
						y: -0.6
					}
				});
			})
			.catch(function (error) {
				/* console.log('VOTE RESPONSE:', error); */
			});
	};

	return (
		<div>
			<Grid
				columns={[null, ['1fr', 3], ['1fr', 3]]}
				gap={['80px 40px', null, null, '80px 50px']}
				px={['m', null, 'l']}
				sx={{ maxWidth: 960, mt: 'xl' }}
				mx="auto"
			>
				{products.map((product, key) => (
					<div className="up_product">
						<div className="sflsjflj">
							<ProgressiveImage src={product.image} placeholder="./images/tiny-image.jpg">
								{(src, loading) => (
									<img
										onClick={() => setToggler(!toggler)}
										style={{ opacity: loading ? 0.2 : 1 }}
										sx={{
											width: '100%',
											maxWidth: '100%',
											display: 'block',
											mb: 's'
										}}
										src={src}
										className="interactive"
										alt={product.id}
									/>
								)}
							</ProgressiveImage>
						</div>

						<div sx={{ mb: 'xl' }}>
							<Heading as="h3" variant="vote.s" sx={{ mb: 'xs', textAlign: 'center' }}>
								{product.title}
							</Heading>
							<Text
								as="p"
								sx={{
									fontSize: 'fs16',
									maxWidth: 320,
									mx: 'auto',
									mb: 'l',
									textAlign: 'center',
									textTransform: 'capitalize'
								}}
							>
								{product.material} | {product.size}
							</Text>
							<Grid gap={10}>
								<Button
									onClick={() => {
										castVote(product.id);
									}}
									sx={{ py: 's', mb:"s" }}
									id={product.id}
									className="tsf"
									disabled
								>
									Vote
								</Button>

								<Button
									onClick={() => {
										productDesc(product)
									}}
									variant="secondary"
									sx={{ py: 'xs' }}
									
									className="tsf"
								>
									Details
								</Button>
							</Grid>
						</div>
					</div>
				))}
				<FsLightbox
					toggler={toggler}
					disableLocalStorage={true}
					sources={[
						'./images/assets/k01.jpg',
						'./images/assets/k02.jpg',
						'./images/assets/k03.jpg',
						'./images/assets/k04.jpg',
						'./images/assets/k05.jpg',
						'./images/assets/k06.jpg'
					]}
				/>
			</Grid>
		</div>
	);
}
